import React from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import {NavLink as RouterLink} from 'react-router-dom';

const AppLink = ({href, children, ...rest}) => {
  return (
    <Link component={RouterLink} {...rest} to={href ?? '#'}>
      {children}
    </Link>
  );
};

export default AppLink;

AppLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
};
